import React, { useState } from 'react';

const QUIZ_FR = [
  {
    id: 'q1',
    question: 'Vous recevez un courrier CAF avec "Objet : demande de justificatifs". Vous devez...',
    options: [
      { id: 'a', text: '😰 Paniquer — c\'est sûrement un problème grave', correct: false },
      { id: 'b', text: '📋 Rassembler les documents demandés et les envoyer dans les délais', correct: true },
      { id: 'c', text: '🙈 Ignorer — ça va s\'arranger tout seul', correct: false },
    ],
    feedback: {
      correct: 'Exactement ! Une demande de justificatifs n\'est pas un refus. C\'est juste une action à faire.',
      wrong: 'Ce n\'est pas la bonne réaction. Ce courrier demande simplement des documents — pas de panique !',
    },
    module: 'courrier',
  },
  {
    id: 'q2',
    question: 'Pour signer un PDF officiel sur votre ordinateur, il faut...',
    options: [
      { id: 'a', text: '🖨️ Imprimer, signer à la main, puis scanner', correct: false },
      { id: 'b', text: '✍️ Utiliser la fonction signature d\'un lecteur PDF comme Adobe ou Acrobat', correct: true },
      { id: 'c', text: '📧 L\'envoyer sans signature en expliquant pourquoi', correct: false },
    ],
    feedback: {
      correct: 'Bravo ! On peut signer numériquement sans imprimer. Un lecteur PDF suffit.',
      wrong: 'Bonne tentative ! Mais on peut signer directement sur ordinateur avec un lecteur PDF.',
    },
    module: 'pdf',
  },
];

const QUIZ_PT = [
  {
    id: 'q1',
    question: 'Recebe uma carta da CAF com "Assunto: pedido de documentos". Deve...',
    options: [
      { id: 'a', text: '😰 Entrar em pânico — é certamente um problema grave', correct: false },
      { id: 'b', text: '📋 Reunir os documentos pedidos e enviá-los dentro do prazo', correct: true },
      { id: 'c', text: '🙈 Ignorar — vai resolver-se sozinho', correct: false },
    ],
    feedback: {
      correct: 'Exacto! Um pedido de documentos não é uma recusa. É apenas uma acção a fazer.',
      wrong: 'Não é a reacção correcta. A carta pede simplesmente documentos — sem pânico!',
    },
    module: 'courrier',
  },
  {
    id: 'q2',
    question: 'Para assinar um PDF oficial no computador, é preciso...',
    options: [
      { id: 'a', text: '🖨️ Imprimir, assinar à mão e depois digitalizar', correct: false },
      { id: 'b', text: '✍️ Usar a função de assinatura de um leitor PDF como Adobe ou Acrobat', correct: true },
      { id: 'c', text: '📧 Enviá-lo sem assinatura a explicar porquê', correct: false },
    ],
    feedback: {
      correct: 'Muito bem! Pode assinar digitalmente sem imprimir. Um leitor PDF é suficiente.',
      wrong: 'Boa tentativa! Mas pode assinar directamente no computador com um leitor PDF.',
    },
    module: 'pdf',
  },
];

const QUIZ_AR = [
  {
    id: 'q1',
    question: 'تلقّيت رسالة من CAF بموضوع "طلب وثائق إثبات". ماذا يجب أن تفعل؟',
    options: [
      { id: 'a', text: '😰 الذعر — إنها بالتأكيد مشكلة خطيرة', correct: false },
      { id: 'b', text: '📋 جمع الوثائق المطلوبة وإرسالها في الأجل المحدد', correct: true },
      { id: 'c', text: '🙈 تجاهلها — ستُحل وحدها', correct: false },
    ],
    feedback: {
      correct: 'صحيح تماماً! طلب الوثائق ليس رفضاً. إنه مجرد إجراء يجب القيام به.',
      wrong: 'هذه ليست ردة الفعل الصحيحة. الرسالة تطلب فقط وثائق — لا داعي للقلق!',
    },
    module: 'courrier',
  },
  {
    id: 'q2',
    question: 'لتوقيع ملف PDF رسمي على حاسوبك، يجب...',
    options: [
      { id: 'a', text: '🖨️ طباعته، التوقيع يدوياً، ثم فحصه', correct: false },
      { id: 'b', text: '✍️ استخدام خاصية التوقيع في قارئ PDF مثل Adobe أو Acrobat', correct: true },
      { id: 'c', text: '📧 إرساله بدون توقيع مع الشرح', correct: false },
    ],
    feedback: {
      correct: 'أحسنت! يمكن التوقيع رقمياً بدون طباعة. قارئ PDF يكفي.',
      wrong: 'محاولة جيدة! لكن يمكن التوقيع مباشرة على الحاسوب بقارئ PDF.',
    },
    module: 'pdf',
  },
];

const QUIZ_EN = [
  {
    id: 'q1',
    question: 'You receive a CAF letter with "Subject: request for supporting documents". You should...',
    options: [
      { id: 'a', text: '😰 Panic — it must be a serious problem', correct: false },
      { id: 'b', text: '📋 Gather the requested documents and send them within the deadline', correct: true },
      { id: 'c', text: '🙈 Ignore it — it will sort itself out', correct: false },
    ],
    feedback: {
      correct: 'Exactly! A request for documents is not a refusal. It is simply something you need to do.',
      wrong: 'That is not the right reaction. The letter just asks for documents — no need to panic!',
    },
    module: 'courrier',
  },
  {
    id: 'q2',
    question: 'To sign an official PDF on your computer, you need to...',
    options: [
      { id: 'a', text: '🖨️ Print it, sign by hand, then scan', correct: false },
      { id: 'b', text: '✍️ Use the signature function in a PDF reader like Adobe or Acrobat', correct: true },
      { id: 'c', text: '📧 Send it without a signature and explain why', correct: false },
    ],
    feedback: {
      correct: 'Well done! You can sign digitally without printing. A PDF reader is all you need.',
      wrong: 'Good try! But you can sign directly on your computer using a PDF reader.',
    },
    module: 'pdf',
  },
];

const QUIZ_IT = [
  {
    id: 'q1',
    question: 'Ricevi una lettera CAF con "Oggetto: richiesta di documenti giustificativi". Devi...',
    options: [
      { id: 'a', text: '😰 Andare nel panico — è sicuramente un problema grave', correct: false },
      { id: 'b', text: '📋 Raccogliere i documenti richiesti e inviarli entro la scadenza', correct: true },
      { id: 'c', text: '🙈 Ignorarla — si sistemerà da sola', correct: false },
    ],
    feedback: {
      correct: 'Esatto! Una richiesta di documenti non è un rifiuto. È semplicemente qualcosa da fare.',
      wrong: 'Non è la reazione giusta. La lettera chiede semplicemente dei documenti — niente panico!',
    },
    module: 'courrier',
  },
  {
    id: 'q2',
    question: 'Per firmare un PDF ufficiale sul computer, bisogna...',
    options: [
      { id: 'a', text: '🖨️ Stampare, firmare a mano, poi scansionare', correct: false },
      { id: 'b', text: '✍️ Usare la funzione firma di un lettore PDF come Adobe o Acrobat', correct: true },
      { id: 'c', text: '📧 Inviarlo senza firma spiegando il motivo', correct: false },
    ],
    feedback: {
      correct: 'Bravo! Si può firmare digitalmente senza stampare. Un lettore PDF è sufficiente.',
      wrong: 'Buon tentativo! Ma si può firmare direttamente sul computer con un lettore PDF.',
    },
    module: 'pdf',
  },
];

const QUIZ_ES = [
  {
    id: 'q1',
    question: 'Recibes una carta de la CAF con "Asunto: solicitud de documentos justificativos". Debes...',
    options: [
      { id: 'a', text: '😰 Entrar en pánico — seguramente es un problema grave', correct: false },
      { id: 'b', text: '📋 Reunir los documentos solicitados y enviarlos en el plazo indicado', correct: true },
      { id: 'c', text: '🙈 Ignorarla — se solucionará solo', correct: false },
    ],
    feedback: {
      correct: '¡Exacto! Una solicitud de documentos no es una negativa. Es simplemente algo que hay que hacer.',
      wrong: 'No es la reacción correcta. La carta solo pide documentos — ¡sin pánico!',
    },
    module: 'courrier',
  },
  {
    id: 'q2',
    question: 'Para firmar un PDF oficial en tu ordenador, hay que...',
    options: [
      { id: 'a', text: '🖨️ Imprimirlo, firmarlo a mano y luego escanearlo', correct: false },
      { id: 'b', text: '✍️ Usar la función de firma de un lector PDF como Adobe o Acrobat', correct: true },
      { id: 'c', text: '📧 Enviarlo sin firma explicando el motivo', correct: false },
    ],
    feedback: {
      correct: '¡Muy bien! Se puede firmar digitalmente sin imprimir. Con un lector PDF es suficiente.',
      wrong: '¡Buena idea! Pero se puede firmar directamente en el ordenador con un lector PDF.',
    },
    module: 'pdf',
  },
];

const QUIZ_ZH = [
  {
    id: 'q1',
    question: '您收到一封CAF来信，主题为"申请证明材料"。您应该……',
    options: [
      { id: 'a', text: '😰 惊慌 — 这肯定是个严重的问题', correct: false },
      { id: 'b', text: '📋 收集所要求的材料并在截止日期前寄出', correct: true },
      { id: 'c', text: '🙈 不理睬 — 问题会自动解决的', correct: false },
    ],
    feedback: {
      correct: '完全正确！申请材料不是拒绝，只是需要办理的手续。',
      wrong: '这不是正确的反应。这封信只是要求提供材料——不必惊慌！',
    },
    module: 'courrier',
  },
  {
    id: 'q2',
    question: '要在电脑上签署一份正式PDF文件，您需要……',
    options: [
      { id: 'a', text: '🖨️ 打印出来、手写签名，再扫描', correct: false },
      { id: 'b', text: '✍️ 使用Adobe或Acrobat等PDF阅读器的签名功能', correct: true },
      { id: 'c', text: '📧 不签名直接发送并说明原因', correct: false },
    ],
    feedback: {
      correct: '太棒了！不用打印也可以进行数字签名，一个PDF阅读器就够了。',
      wrong: '好尝试！但实际上可以直接在电脑上用PDF阅读器签名。',
    },
    module: 'pdf',
  },
];

const LEVELS_FR = {
  0: { label: 'Débutant', emoji: '🌱', color: '#10B981', desc: 'Pas d\'inquiétude — DémarchesClaires est fait pour vous !', module: 'courrier' },
  1: { label: 'En progression', emoji: '🌿', color: '#F59E0B', desc: 'Vous avez de bonnes bases. Quelques modules vous rendront autonome.', module: 'pdf' },
  2: { label: 'À l\'aise', emoji: '🌳', color: '#3B82F6', desc: 'Vous vous débrouillez bien. Approfondissez vos points faibles.', module: 'securite' },
};

const LEVELS_PT = {
  0: { label: 'Principiante', emoji: '🌱', color: '#10B981', desc: 'Sem preocupação — DémarchesClaires foi feito para si!', module: 'courrier' },
  1: { label: 'Em progressão', emoji: '🌿', color: '#F59E0B', desc: 'Tem boas bases. Alguns módulos vão torná-lo autónomo.', module: 'pdf' },
  2: { label: 'À vontade', emoji: '🌳', color: '#3B82F6', desc: 'Desenrasca-se bem. Aprofunde os seus pontos fracos.', module: 'securite' },
};

const LEVELS_AR = {
  0: { label: 'مبتدئ', emoji: '🌱', color: '#10B981', desc: 'لا داعي للقلق — DémarchesClaires مصمم لمساعدتك!', module: 'courrier' },
  1: { label: 'في تقدم', emoji: '🌿', color: '#F59E0B', desc: 'لديك أسس جيدة. بعض الدروس ستجعلك مستقلاً.', module: 'pdf' },
  2: { label: 'مرتاح', emoji: '🌳', color: '#3B82F6', desc: 'تتصرف بشكل جيد. عزّز نقاط ضعفك.', module: 'securite' },
};

const LEVELS_EN = {
  0: { label: 'Beginner', emoji: '🌱', color: '#10B981', desc: 'No worries — DémarchesClaires is made for you!', module: 'courrier' },
  1: { label: 'Progressing', emoji: '🌿', color: '#F59E0B', desc: 'You have good foundations. A few modules will make you independent.', module: 'pdf' },
  2: { label: 'Comfortable', emoji: '🌳', color: '#3B82F6', desc: 'You manage well. Deepen your weak points.', module: 'securite' },
};

const LEVELS_IT = {
  0: { label: 'Principiante', emoji: '🌱', color: '#10B981', desc: 'Nessuna preoccupazione — DémarchesClaires è fatto per te!', module: 'courrier' },
  1: { label: 'In progressione', emoji: '🌿', color: '#F59E0B', desc: 'Hai buone basi. Alcuni moduli ti renderanno autonomo.', module: 'pdf' },
  2: { label: 'A proprio agio', emoji: '🌳', color: '#3B82F6', desc: 'Te la cavi bene. Approfondisci i tuoi punti deboli.', module: 'securite' },
};

const LEVELS_ES = {
  0: { label: 'Principiante', emoji: '🌱', color: '#10B981', desc: 'Sin preocupaciones — ¡DémarchesClaires está hecho para ti!', module: 'courrier' },
  1: { label: 'En progreso', emoji: '🌿', color: '#F59E0B', desc: 'Tienes buenas bases. Algunos módulos te harán autónomo.', module: 'pdf' },
  2: { label: 'Cómodo', emoji: '🌳', color: '#3B82F6', desc: 'Te manejas bien. Profundiza tus puntos débiles.', module: 'securite' },
};

const LEVELS_ZH = {
  0: { label: '初学者', emoji: '🌱', color: '#10B981', desc: '别担心 — DémarchesClaires 就是为您准备的！', module: 'courrier' },
  1: { label: '进步中', emoji: '🌿', color: '#F59E0B', desc: '您有良好的基础。几个模块将让您独立完成手续。', module: 'pdf' },
  2: { label: '轻松应对', emoji: '🌳', color: '#3B82F6', desc: '您掌握得很好。深化您的薄弱环节。', module: 'securite' },
};

const UI = {
  fr: {
    title: 'Testez votre niveau en 2 questions',
    subtitle: 'Résultat immédiat + module recommandé',
    start: 'Commencer le test →',
    niveau: 'Niveau',
    bonnes: 'bonnes réponses',
    recommande: 'Module recommandé →',
    recommencer: 'Recommencer le test',
    question: 'Question',
    suivante: 'Question suivante →',
    resultat: 'Voir mon résultat →',
  },
  pt: {
    title: 'Teste o seu nível em 2 perguntas',
    subtitle: 'Resultado imediato + módulo recomendado',
    start: 'Começar o teste →',
    niveau: 'Nível',
    bonnes: 'respostas correctas',
    recommande: 'Módulo recomendado →',
    recommencer: 'Recomeçar o teste',
    question: 'Pergunta',
    suivante: 'Pergunta seguinte →',
    resultat: 'Ver o meu resultado →',
  },
  ar: {
    title: 'اختبر مستواك في سؤالين',
    subtitle: 'نتيجة فورية + درس موصى به',
    start: '← ابدأ الاختبار',
    niveau: 'المستوى',
    bonnes: 'إجابات صحيحة',
    recommande: '← الدرس الموصى به',
    recommencer: 'إعادة الاختبار',
    question: 'سؤال',
    suivante: 'السؤال التالي ←',
    resultat: 'شاهد نتيجتي ←',
  },
  en: {
    title: 'Test your level in 2 questions',
    subtitle: 'Immediate result + recommended module',
    start: 'Start the test →',
    niveau: 'Level',
    bonnes: 'correct answers',
    recommande: 'Recommended module →',
    recommencer: 'Retake the test',
    question: 'Question',
    suivante: 'Next question →',
    resultat: 'See my result →',
  },
  it: {
    title: 'Metti alla prova il tuo livello in 2 domande',
    subtitle: 'Risultato immediato + modulo consigliato',
    start: 'Inizia il test →',
    niveau: 'Livello',
    bonnes: 'risposte corrette',
    recommande: 'Modulo consigliato →',
    recommencer: 'Rifare il test',
    question: 'Domanda',
    suivante: 'Domanda successiva →',
    resultat: 'Vedi il mio risultato →',
  },
  es: {
    title: 'Pon a prueba tu nivel en 2 preguntas',
    subtitle: 'Resultado inmediato + módulo recomendado',
    start: 'Empezar el test →',
    niveau: 'Nivel',
    bonnes: 'respuestas correctas',
    recommande: 'Módulo recomendado →',
    recommencer: 'Repetir el test',
    question: 'Pregunta',
    suivante: 'Siguiente pregunta →',
    resultat: 'Ver mi resultado →',
  },
  zh: {
    title: '用2个问题测试您的水平',
    subtitle: '即时结果 + 推荐模块',
    start: '开始测试 →',
    niveau: '水平',
    bonnes: '正确答案',
    recommande: '推荐模块 →',
    recommencer: '重新测试',
    question: '问题',
    suivante: '下一个问题 →',
    resultat: '查看我的结果 →',
  },
};

const QUIZ_MAP = { fr: QUIZ_FR, pt: QUIZ_PT, ar: QUIZ_AR, en: QUIZ_EN, it: QUIZ_IT, es: QUIZ_ES, zh: QUIZ_ZH };
const LEVELS_MAP = { fr: LEVELS_FR, pt: LEVELS_PT, ar: LEVELS_AR, en: LEVELS_EN, it: LEVELS_IT, es: LEVELS_ES, zh: LEVELS_ZH };

export default function MiniQuiz({ onNavigate, scale = 1, lang }) {
  const [started, setStarted] = useState(false);
  const [step, setStep] = useState(0);
  const [answered, setAnswered] = useState(null);
  const [showFeedback, setShowFeedback] = useState(false);
  const [score, setScore] = useState(0);
  const [done, setDone] = useState(false);

  const isAr = lang === 'ar';
  const activeLang = QUIZ_MAP[lang] ? lang : 'fr';

  const QUIZ = QUIZ_MAP[activeLang];
  const LEVELS = LEVELS_MAP[activeLang];
  const ui = UI[lang] || UI.fr;

  const q = QUIZ[step];
  const result = LEVELS[score] || LEVELS[0];

  const handleAnswer = (opt) => {
    if (answered) return;
    setAnswered(opt.id);
    if (opt.correct) setScore(s => s + 1);
    setTimeout(() => setShowFeedback(true), 400);
  };

  const handleNext = () => {
    if (step < QUIZ.length - 1) {
      setStep(s => s + 1);
      setAnswered(null);
      setShowFeedback(false);
    } else {
      setDone(true);
    }
  };

  const reset = () => {
    setStarted(false); setStep(0); setAnswered(null);
    setShowFeedback(false); setScore(0); setDone(false);
  };

  const getState = (opt) => {
    if (!answered) return 'default';
    if (opt.correct) return 'correct';
    if (opt.id === answered && !opt.correct) return 'wrong';
    return 'default';
  };

  if (!started) {
    return (
      <div style={{
        background: 'rgba(255,255,255,0.08)',
        border: '1px solid rgba(245,158,11,0.2)',
        borderRadius: 20, padding: '0.5rem',
        direction: isAr ? 'rtl' : 'ltr',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
          <span style={{ fontSize: 32 }}>🧠</span>
          <div>
            <div style={{ fontSize: 15 * scale, fontWeight: 700, color: '#F59E0B', fontFamily: 'Fraunces, serif' }}>
              {ui.title}
            </div>
            <div style={{ fontSize: 12 * scale, color: 'rgba(255,255,255,0.6)', marginTop: 2 }}>
              {ui.subtitle}
            </div>
          </div>
        </div>
        <button onClick={() => setStarted(true)} style={{
          width: '100%', padding: '13px',
          background: 'linear-gradient(135deg, #F59E0B, #FCD34D)',
          color: '#1E3A5F', fontSize: 14 * scale, fontWeight: 700,
          borderRadius: 14, border: 'none', cursor: 'pointer',
          boxShadow: '0 4px 16px rgba(245,158,11,0.3)',
          textAlign: 'center',
        }}>
          {ui.start}
        </button>
      </div>
    );
  }

  if (done) {
    return (
      <div style={{
        background: 'rgba(255,255,255,0.08)',
        border: `1px solid ${result.color}40`,
        borderRadius: 20, padding: '0.5rem',
        textAlign: 'center',
        direction: isAr ? 'rtl' : 'ltr',
      }}>
        <div style={{ fontSize: 40, marginBottom: 8 }}>{result.emoji}</div>
        <div style={{ fontSize: 18 * scale, fontWeight: 700, color: '#fff', marginBottom: 6, fontFamily: 'Fraunces, serif' }}>
          {ui.niveau} : {result.label}
        </div>
        <div style={{
          display: 'inline-block',
          background: `${result.color}20`, color: result.color,
          fontSize: 12 * scale, fontWeight: 700,
          padding: '4px 14px', borderRadius: 20, marginBottom: 12,
        }}>
          {score} / {QUIZ.length} {ui.bonnes}
        </div>
        <div style={{ fontSize: 13 * scale, color: 'rgba(255,255,255,0.7)', lineHeight: 1.6, marginBottom: 20 }}>
          {result.desc}
        </div>
        <button onClick={() => onNavigate('module', result.module)} style={{
          width: '100%', padding: '12px',
          background: 'linear-gradient(135deg, #F59E0B, #FCD34D)',
          color: '#1E3A5F', fontSize: 14 * scale, fontWeight: 700,
          borderRadius: 12, border: 'none', cursor: 'pointer', marginBottom: 8,
        }}>
          {ui.recommande}
        </button>
        <button onClick={reset} style={{
          width: '100%', padding: '10px',
          background: 'transparent', color: 'rgba(255,255,255,0.4)',
          fontSize: 12 * scale, border: 'none', cursor: 'pointer',
        }}>
          {ui.recommencer}
        </button>
      </div>
    );
  }

  return (
    <div style={{
      background: 'rgba(255,255,255,0.08)',
      border: '1px solid rgba(245,158,11,0.2)',
      borderRadius: 20, padding: '0.5rem',
      direction: isAr ? 'rtl' : 'ltr',
    }}>
      <div style={{ display: 'flex', gap: 6, marginBottom: 16 }}>
        {QUIZ.map((_, i) => (
          <div key={i} style={{
            flex: 1, height: 4, borderRadius: 4,
            background: i < step ? '#F59E0B' : i === step ? '#FCD34D' : 'rgba(255,255,255,0.15)',
            transition: 'background 0.3s ease',
          }} />
        ))}
      </div>
      <div style={{ fontSize: 11 * scale, color: '#F59E0B', fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 10 }}>
        🧠 {ui.question} {step + 1} / {QUIZ.length}
      </div>
      <div style={{ fontSize: 15 * scale, fontWeight: 700, color: '#fff', marginBottom: 16, lineHeight: 1.5, fontFamily: 'Fraunces, serif' }}>
        {q.question}
      </div>
      {q.options.map(opt => {
        const state = getState(opt);
        return (
          <button key={opt.id} onClick={() => handleAnswer(opt)} style={{
            width: '100%', padding: '12px 16px', borderRadius: 12, marginBottom: 8,
            border: `2px solid ${state === 'correct' ? '#10B981' : state === 'wrong' ? '#EF4444' : 'rgba(255,255,255,0.15)'}`,
            background: state === 'correct' ? 'rgba(16,185,129,0.15)' : state === 'wrong' ? 'rgba(239,68,68,0.15)' : 'rgba(255,255,255,0.05)',
            color: '#fff', fontSize: 13 * scale, fontWeight: 500,
            cursor: answered ? 'default' : 'pointer',
            textAlign: isAr ? 'right' : 'left',
            transition: 'all 0.2s ease',
          }}>
            {state === 'correct' ? '✓ ' : state === 'wrong' ? '✗ ' : ''}{opt.text}
          </button>
        );
      })}
      {showFeedback && (
        <>
          <div style={{
            background: answered && q.options.find(o => o.id === answered)?.correct
              ? 'rgba(16,185,129,0.15)' : 'rgba(239,68,68,0.1)',
            border: `1px solid ${answered && q.options.find(o => o.id === answered)?.correct ? '#10B981' : '#EF4444'}40`,
            borderRadius: 12, padding: '12px', marginTop: 4,
            fontSize: 13 * scale, color: 'rgba(255,255,255,0.85)', lineHeight: 1.5,
          }}>
            💡 {answered && q.options.find(o => o.id === answered)?.correct
              ? q.feedback.correct : q.feedback.wrong}
          </div>
          <button onClick={handleNext} style={{
            width: '100%', padding: '12px', marginTop: 10,
            background: 'linear-gradient(135deg, #1E3A5F, #2A4F7F)',
            color: '#fff', fontSize: 13 * scale, fontWeight: 700,
            borderRadius: 12, border: 'none', cursor: 'pointer',
          }}>
            {step < QUIZ.length - 1 ? ui.suivante : ui.resultat}
          </button>
        </>
      )}
    </div>
  );
}
